export function addCurrent(unit) {
  return {
      type: 'ADD_CURRENT',
      unit,
  }
}